<template>
  <div
      v-if="!isOk"
      class="connection-canary"
      :class="connectionStatus"
      :title="tooltip"
  >
    <VIcon :material="icon" />
    <span class="label">{{ label }}</span>
  </div>
</template>

<script lang="ts">
import RpcService from '@/core/services/Rpc/RpcService';

export default defineComponent({
  name: 'VConnectionCanary',

  computed: {
    connectionStatus(): 'ok' | 'warning' | 'critical' {
      return RpcService.connectionStatus.value;
    },

    isOk(): boolean {
      return this.connectionStatus === 'ok';
    },

    isWarning(): boolean {
      return this.connectionStatus === 'warning';
    },

    isCritical(): boolean {
      return this.connectionStatus === 'critical';
    },

    icon(): string {
      if (this.isCritical) {
        return 'wifi_off';
      }

      return 'signal_wifi_bad';
    },

    label(): string {
      if (this.isCritical) {
        return 'Связь потеряна';
      }

      return 'Нестабильная связь';
    },

    tooltip(): string {
      if (this.isCritical) {
        return 'Несколько запросов подряд не дошли до сервера. Проверьте подключение к интернету.';
      }

      return 'Запросы начали пропадать. Возможны проблемы со связью.';
    },
  },
});
</script>

<style lang="scss">
.connection-canary {
  position: absolute;
  width: 220px;
  z-index: 200;
  bottom: 60px;
  height: 80px;
  right: calc(50% - 110px);
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 6px;

  font-size: 16px;
  padding: 4px 10px;
  font-weight: bold;
  border-radius: 4px;
  line-height: 16px;

  > .mds-icon {
    font-size: 16px;
  }

  &.warning {
    background: var(--warning-weak);
    color: var(--warning-strong);
    border: 1px solid var(--warning-strong);
  }

  &.critical {
    background: var(--critic-weak);
    color: var(--critic-strong);
    border: 1px solid var(--critic-strong);

    animation: connection-canary-pulse 1s infinite;
  }
}

@keyframes connection-canary-pulse {
  50% { opacity: 0.5; }
}
</style>
